import React, { useState } from "react";

const AboutPageForm = ({ onSubmit, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    heading: initialData.heading || "",
    para: initialData.para || "",
    imageurl: null, // must be File object
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "imageurl" && files.length > 0) {
      setFormData({ ...formData, imageurl: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="p-3 border rounded">
      <div className="mb-3">
        <label>Heading</label>
        <input
          type="text"
          className="form-control"
          name="heading"
          value={formData.heading}
          onChange={handleChange}
        />
      </div>
      <div className="mb-3">
        <label>Paragraph</label>
        <textarea
          className="form-control"
          name="para"
          value={formData.para}
          onChange={handleChange}
        />
      </div>
      <div className="mb-3">
        <label>Image</label>
        <input
          type="file"
          className="form-control"
          name="imageurl"
          onChange={handleChange}
        />
      </div>
      <button type="submit" className="btn btn-primary me-2">
        Save
      </button>
      <button
        type="button"
        className="btn btn-secondary"
        onClick={onCancel}
      >
        Cancel
      </button>
    </form>
  );
};

export default AboutPageForm;
